import { render } from "./Music.vue?vue&type=template&id=31b5d015"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"

import "./Music.vue?vue&type=style&index=0&id=31b5d015&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__